import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import {V1ProjectPlanPhaseMilestoneIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import MemoryContext from "../../../../util/MemoryContext";


class ProjectPlanPhaseMilestoneEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocRequest = this.getIDOCRequest() ?? "v1.ProjectPlanPhaseMilestone-001";
        let idocResponse = this.getIDOCResponse() ?? "v1.ProjectPlanPhaseMilestone-001";

        let fk = {};
        fk["ProjectPlanPhaseUSID"] = foreignKey;

        AxiosFoundationAPI({
            method: "GET",
            url: "t1/v1/project_plan_phase_milestones",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...(foreignKey ? fk : {}),
                ...this.getSearchSpecification(),
                "USID": this.getAttributeValue("USID"),
            },
            headers: {
                "idoc-request": idocRequest,
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectPlanPhaseMilestoneIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.ProjectPlanPhaseMilestone-001";
        payload.PlatformMessage.ProjectPlanPhaseMilestone = this.preparePUTPayload();

        return payload;
    };

    performUpdate = () => {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t1/v1/project_plan_phase_milestones",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseMilestone-001",
                "idoc-response": "v1.ProjectPlanPhaseMilestone-001",
            },
        };
        this.notifyUpdateStartListeners();
        AxiosFoundationAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1ProjectPlanPhaseMilestoneIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let projectPlanPhaseMilestone = {};

        if (this.getAttributeValue("MilestoneToCopyUSID") !== null && this.getAttributeValue("MilestoneToCopyUSID") !== undefined) {
            projectPlanPhaseMilestone["MilestoneToCopyUSID"] = this.getAttributeValue("MilestoneToCopyUSID");
            projectPlanPhaseMilestone["MilestoneToCopyNewName"] = this.getAttributeValue("MilestoneToCopyNewName");
            this.setIDOCResponse(null);
        } else {
            projectPlanPhaseMilestone["USID"] = this.getAttributeValue("USID");
            projectPlanPhaseMilestone["Name"] = this.getAttributeValue("Name");
            projectPlanPhaseMilestone["Description"] = this.getAttributeValue("Description");
            projectPlanPhaseMilestone["ProjectPlanPhaseUSID"] = MemoryContext.components["ProjectPlanDetail-EO-PhaseUSID"];
            projectPlanPhaseMilestone["StartDatetime"] = this.getAttributeValue("StartDatetime");
            projectPlanPhaseMilestone["DueDatetime"] = this.getAttributeValue("DueDatetime");
            projectPlanPhaseMilestone["Notes"] = this.getAttributeValue("Notes");
        }

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.ProjectPlanPhaseMilestone-001";
        payload.PlatformMessage.ProjectPlanPhaseMilestone = projectPlanPhaseMilestone;

        return payload;
    };

    performInsert = () => {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t1/v1/project_plan_phase_milestones",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseMilestone-001",
                "idoc-response": this.getIDOCResponse(),
            },
        };
        this.notifyInsertStartListeners();
        AxiosFoundationAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1ProjectPlanPhaseMilestoneIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {};

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.ProjectPlanPhaseMilestone-002";
        payload.PlatformMessage.ProjectPlanPhaseMilestone = {
            "USID": this.getAttributeValue("USID")
        };

        let options = {
            method: "DELETE",
            url: "t1/v1/project_plan_phase_milestones",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseMilestone-002",
                "idoc-response": "v1.ProjectPlanPhaseMilestone-002",
            },
        };
        this.notifyDeleteStartListeners();
        AxiosFoundationAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default ProjectPlanPhaseMilestoneEnterpriseComponent;